import React from 'react';
import './App.css';

function App() {
  return (
    <div className="page">
      <header className="site-header">
        <div className="container">
          <div className="hero-grid">
            <div className="hero-main">
              <h1>Zack Richardson</h1>
              <p className="hero-summary">
                Software Engineer with 6 years of experience in distributed systems, observability, and cloud infrastructure.
                Interested in building solutions for developer productivity and workflow automation.
              </p>
            </div>

            <aside className="hero-aside">
              <div className="profile-wrapper">
                <img
                  src="mugshot_2023.png"
                  alt="Zack Richardson"
                  className="profile-img"
                />
              </div>
              <div className="cta-stack">
                <a
                  href="https://drive.google.com/file/d/10ESQx1BMwhtk5Np_HGtnoaHTARkn-eRl/view?usp=sharing"
                  className="primary-cta"
                >
                  <span>PDF Resume</span>
                </a>
                <div className="icon-links">
                  <a
                    href="https://www.linkedin.com/in/richardsonz/"
                    className="icon-link"
                    aria-label="LinkedIn"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="18"
                      height="18"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z"></path>
                      <rect x="2" y="9" width="4" height="12"></rect>
                      <circle cx="4" cy="4" r="2"></circle>
                    </svg>
                  </a>
                  <a
                    href="https://github.com/ZRich97"
                    className="icon-link"
                    aria-label="GitHub"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="18"
                      height="18"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <path d="M9 19c-5 1.5-5-2.5-7-3m14 6v-3.87a3.37 3.37 0 0 0-.94-2.61c3.14-.35 6.44-1.54 6.44-7A5.44 5.44 0 0 0 20 4.77 5.07 5.07 0 0 0 19.91 1S18.73.65 16 2.48a13.38 13.38 0 0 0-7 0C6.27.65 5.09 1 5.09 1A5.07 5.07 0 0 0 5 4.77a5.44 5.44 0 0 0-1.5 3.78c0 5.42 3.3 6.61 6.44 7A3.37 3.37 0 0 0 9 18.13V22"></path>
                    </svg>
                  </a>
                  <a
                    href="https://gallery.zrich.dev"
                    className="icon-link"
                    aria-label="Photography"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="18"
                      height="18"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <path d="M23 19V7a2 2 0 0 0-2-2h-3.17a2 2 0 0 1-1.41-.59l-1.83-1.82a2 2 0 0 0-1.41-.59H8a2 2 0 0 0-2 2H3a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h18a2 2 0 0 0 2-2z"></path>
                      <circle cx="12" cy="13" r="4"></circle>
                    </svg>
                  </a>
                </div>
              </div>
            </aside>
          </div>
        </div>
      </header>

      <main>
        <section id="experience" className="section">
          <div className="container">
            <div className="section-header">
              <h2>Experience</h2>
            </div>

            <div className="experience-list">
              <article className="experience-card">
                <header className="experience-card-header">
                  <div className="experience-card-left">
                    <img
                      src="https://avatars.githubusercontent.com/u/47237323?s=200&v=4"
                      alt="Anduril logo"
                      className="company-logo"
                    />
                    <div className="experience-card-main">
                      <h3>Anduril Industries</h3>
                      <p className="role">Site Reliability Engineer</p>
                    </div>
                  </div>
                  <div className="experience-card-meta">
                    <span>Sep 2025 – Present</span>
                    <span>Seattle, WA</span>
                  </div>
                </header>
                <ul>
                  <li>
                    Member of the Software Integration Environment (SIE) team building a development platform for simulation and integration testing, deployed both for internal developers and external customers
                  </li>
                </ul>
              </article>

              <article className="experience-card">
                <header className="experience-card-header">
                  <div className="experience-card-left">
                    <img
                      src="https://avatars.githubusercontent.com/u/6154722?s=200&v=4"
                      alt="Microsoft logo"
                      className="company-logo"
                    />
                    <div className="experience-card-main">
                      <h3>Microsoft</h3>
                      <p className="role">Software Engineer II</p>
                    </div>
                  </div>
                  <div className="experience-card-meta">
                    <span>May 2022 – Sept 2025</span>
                    <span>Redmond, WA</span>
                  </div>
                </header>
                <ul>
                  <li>
                    Architected a system leveraging Azure OpenAI and RAG techniques to author
                    troubleshooting documentation and automate incident response, reducing
                    time-to-mitigate and improving documentation quality by ~30%
                  </li>
                  <li>
                    Led OpenTelemetry standardization across 20+ services, designing extensible
                    instrumentation libraries that maintained backwards compatibility while
                    enabling unified metrics and traces
                  </li>
                  <li>
                    Implemented a C# IaC library generating ARM templates, reducing provisioning
                    complexity and saving developer hours via standardized deployment patterns
                  </li>
                  <li>
                    Built and maintained .NET libraries consumed by dozens of services, including
                    a CosmosDB client wrapper and authentication middleware
                  </li>
                </ul>
              </article>

              <article className="experience-card">
                <header className="experience-card-header">
                  <div className="experience-card-left">
                    <img
                      src="https://avatars.githubusercontent.com/u/6154722?s=200&v=4"
                      alt="Microsoft logo"
                      className="company-logo"
                    />
                    <div className="experience-card-main">
                      <h3>Microsoft</h3>
                      <p className="role">Software Engineer I</p>
                    </div>
                  </div>
                  <div className="experience-card-meta">
                    <span>Mar 2020 – Apr 2022</span>
                    <span>Redmond, WA</span>
                  </div>
                </header>
                <ul>
                  <li>
                    Migrated legacy Commerce services (100k+ RPS) onto .NET 6 and Azure Kubernetes
                    Service, resulting in cost savings of up to 80% and latency improvements of
                    20%
                  </li>
                  <li>
                    Developed service and infrastructure monitoring solutions using Azure Monitor,
                    Grafana, Prometheus, and Kusto, standardizing observability across services
                  </li>
                </ul>
              </article>

              {/* <article className="experience-card">
                <header className="experience-card-header">
                  <div className="experience-card-left">
                    <img
                      src="https://avatars.githubusercontent.com/u/57341246?s=200&v=4"
                      alt="Expedock logo"
                      className="company-logo"
                    />
                    <div className="experience-card-main">
                      <h3>Expedock</h3>
                      <p className="role">DevOps Intern</p>
                    </div>
                  </div>
                  <div className="experience-card-meta">
                    <span>Oct 2019 – Feb 2020</span>
                    <span>Remote</span>
                  </div>
                </header>
                <ul>
                  <li>
                    Containerized backend services and stood up AWS infrastructure, enabling
                    faster deployments and improving system reliability
                  </li>
                  <li>
                    Part-time role during final quarter of undergraduate studies prior to joining
                    Microsoft full-time
                  </li>
                </ul>
              </article> */}

              <article className="experience-card">
                <header className="experience-card-header">
                  <div className="experience-card-left">
                    <img
                      src="https://avatars.githubusercontent.com/u/2495066?s=200&v=4"
                      alt="Intuit logo"
                      className="company-logo"
                    />
                    <div className="experience-card-main">
                      <h3>Intuit</h3>
                      <p className="role">DevOps SWE Intern</p>
                    </div>
                  </div>
                  <div className="experience-card-meta">
                    <span>Jun 2019 – Sep 2019</span>
                    <span>Mountain View, CA</span>
                  </div>
                </header>
                <ul>
                  <li>
                    Implemented AWS-hosted Jenkins server that decreased time-to-deploy by 60%
                  </li>
                </ul>
              </article>

              <article className="experience-card">
                <header className="experience-card-header">
                  <div className="experience-card-left">
                    <img src="JT4.png" alt="JT4 logo" className="company-logo" />
                    <div className="experience-card-main">
                      <h3>JT4 LLC</h3>
                      <p className="role">Field Engineer I</p>
                    </div>
                  </div>
                  <div className="experience-card-meta">
                    <span>Jun 2017 – Feb 2019</span>
                    <span>Las Vegas, NV</span>
                  </div>
                </header>
                <ul>
                  <li>
                    Built a command-and-control system using Java, Swing, and the NASA WorldWind
                    SDK
                  </li>
                  <li>
                    Migrated multiple build scripts from Apache Ant to Gradle, decreasing build complexity and improving developer
experience
                  </li>
                </ul>
              </article>
            </div>
          </div>
        </section>

        <section id="education" className="section section--compact">
          <div className="container">
            <div className="section-header">
              <h2>Education</h2>
            </div>
            <div className="education-card">
              <div className="education-top">
                <div className="education-logo-wrapper">
                  <img
                    src="https://avatars.githubusercontent.com/u/7508781?s=200&v=4"
                    alt="Cal Poly logo"
                      className="company-logo"
                  />
                </div>
                <div className="education-main">
                  <h3>California Polytechnic State University · San Luis Obispo</h3>
                  <p className="degree">B.S. Software Engineering · 2015–2019</p>
                </div>
              </div>
              <p className="education-detail">
                <strong>Senior Project:</strong> Developed an iOS app using Swift, AWS, and Intuit’s
                CardParts framework to track health goals, workouts, and nutrition
              </p>
            </div>
          </div>
        </section>
      </main>
    </div>
  );
}

export default App;
